enum PaymentStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  COMPLETED = "COMPLETED",
  POSTPONED = "POSTPONED",
  PROCESSING = "PROCESSING",
  CONFIRMING = "CONFIRMING",
  CONFIRMED = "CONFIRMED",
  REVIEW = "REVIEW",
  UNDER_MINIMUM = "UNDER_MINIMUM",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  BLOCKED = "BLOCKED",
  SUCCESS = "SUCCESS",
  CREATED = "CREATED",
}

export default PaymentStatus;
